<template>
    <img 
        v-if="url && !imageFailedToLoad"
        alt=""
        :src="url"
        :class="[
            'w-full h-full',
            imgClass,
        ]"
        @click="$emit('img-click')"
        @error="imageFailedToLoad = true"
    >
    <svg 
        v-else 
        class="fill-current mt-px" 
        xmlns="http://www.w3.org/2000/svg" 
        viewBox="0 0 100 100"
    >
        <path v-if="gender === PersonGender.Female" d="M76.46155,83c-12.25476-3.96295-14.16711-5.41364-14.93152-7.33844,3.90894-.68378,8.23169-1.63141,11.32495-2.849l-1.85498-2.81256s4.65283.26501,8.32642-3.86749c0,0-2.32642-1.13251-3.32642-3.13251,0,0,5.36987-1.19086,7.68494-7.09546,0,0-6.68494-2.90454-7.68494-7.90454s-1.3562-30.64429-23.69238-31.30768c-23.30762-.69232-25.30762,29.30768-25.30762,33.30768s-3.88599,5.98718-6.44312,5.99359c0,0,1.15112,4.21259,6.79712,7.1095l-2.30176,3.09729s1.13245,2.55273,8.54004,4.67615c0,0-1.59229,2.12347,1.40771,3.12347,1.23096.41034,4.31396.98895,7.52185,1.52869-.73303,1.99292-2.44739,3.41742-14.9834,7.47131-15.46155,5-15.53845,17-15.53845,17h80s-.0769-12-15.53845-17Z" />
        <path v-else d="M90.5,92s-.0769-12-15.53857-17c-6.42773-2.07867-10.00513-3.46509-12.06934-4.59222-3.85913-2.54639-2.89209-8.40778-2.89209-8.40778,6-4,7.00732-13.76093,7.00732-13.76093,0,0,1.03174-2.06335,2.06348-3.09509,1.03149-1.03168,0-5.15851,1.03149-8.2536.73291-2.1983-.09399-2.83289-.63574-3.01746.30103-3.68994-.03955-5.93048-.55591-7.28455,1.74194-1.50281.16016-4.14185.16016-4.14185-1.03174,0-2.06348-1.03174-3.28027-2.90997-1.21704-1.87823-3.94189-6.37537-16.00488-6.53412-12.06299-.15869-12.69775,7.38068-12.69775,7.38068,0,0-5.52881.76715-5.34375,11.21643.01392.79016.08691,1.50964.18628,2.19574l-.00122-.00006s-2.06323,0-1.03149,3.09515c1.03149,3.09509,0,7.22192,1.03149,8.2536,1.03174,1.03174,2.06348,3.09509,2.06348,3.09509,0,0,2.00732,9.76093,7.00732,13.76093,0,0,.96704,5.86139-2.89209,8.40778-2.06421,1.12714-5.6416,2.51355-12.06934,4.59222-15.46167,5-15.53857,17-15.53857,17l-1,8h82l-1-8Z" />
    </svg>
</template>
<script setup lang="ts">
    import { ref, watch } from 'vue'

    /** @autodoc App\Enums\PersonGender */
    enum PersonGender {
        Male = 0,
        Female = 1,
    }

    const props = withDefaults(defineProps<{
        url?: string
        gender?: PersonGender
        imgClass?: string
    }>(), {
        url: undefined,
        gender: PersonGender.Male,
        imgClass: '',
    })

    defineEmits(['img-click'])

    const imageFailedToLoad = ref(false)

    watch(() => props.url, () => {
        imageFailedToLoad.value = false
    })

</script>
